import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import useAxiosIntercept from "../../hooks/useAxiosIntercept";
import CustomerListing from "./CustomerListing";
import Pagination from "./Pagination";
import useAuth from "../../hooks/useAuth";
const CustomerInfo = ({ searchValue, keyvalue, setKeyValue, userType}) => {
  const [users, setUsers] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const axiosPrivate = useAxiosIntercept();
  const ref = useRef(true);
  const search_keyword = searchValue;
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage, setUsersPerPage] = useState(5);
  const [total_records, setTotalRecords] = useState(0);
  const [total_pages, setTotalPages] = useState(0);
  let search_by = "firstname";
  const [isLoading, setIsLoading] = useState(false);
  const {auth} = useAuth();

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const phoneRegex = /^\d{8}(\d{2})?$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const nameRegex = /^[A-Za-z]+$/;

    const getUsers = async () => {
      let URL;
      if(auth.is_corporate == 1){
        URL = process.env.REACT_APP_PARTNER_GET_CORP_USER_VEHICLES + '&show_user_vehicle_package_info=1'
      }
      else{
        URL = process.env.REACT_APP_USER_INFO_URL + '&user_type=C' + '&show_partner_customers=1' + '&show_user_vehicle_package_info=1';
      }
      if (searchValue === "")
        URL = URL + `&page=${currentPage}&limit=${usersPerPage}`;
      if (searchValue != "") {
        if (phoneRegex.test(searchValue)) {
          search_by = 'phone';
        } else if (emailRegex.test(searchValue)) {
          search_by = 'email';
        } else if (nameRegex.test(searchValue)) {
          search_by = 'firstname';
        }
        URL =
          URL +
          `&search_by=${search_by}&search_keyword=${search_keyword}&limit=${usersPerPage}&show_partner_customers=1`;
      }

      try {
        setIsLoading(true);
        const response = await axiosPrivate.get(URL, {
          signal: controller.signal,
        });
        setIsLoading(false);
        if(response?.data?.response?.data?.user_info) {
          isMounted && setUsers(response?.data?.response?.data?.user_info);
        }
        setKeyValue("");
        setTotalRecords(response?.data?.response?.data?.total_records);
        setTotalPages(response?.data?.response?.data?.pagination?.total_pages);
        // console.log("total_pages",response?.data?.response?.data?.pagination?.total_pages);
      } catch (err) {
        console.log(err);
        // navigate("/", { state: { from: location }, replace: true });
      }
    };

    // Check if useEffect has run the first time
    // if (!effectRun.current) {
    if(ref.current){
      // ref.current= false;

        getUsers();

    }
    // }`
    return () => {
      isMounted = false;
      // controller.abort();
      // effectRun.current = true; // update the value of effectRun to true
    };
  }, [keyvalue, currentPage, auth.is_corporate]);

  const paginate = (number) => {
    setCurrentPage(number);
  };
  return (
    <>
      <div className="filterBlock dForm mb-16">

      </div>
      {!isLoading ? <CustomerListing users={users} /> : <p>Loading...</p>}
      {users?.[0] && total_pages>1 && <Pagination
        paginate={paginate}
        currentPage={currentPage}
        usersPerPage={usersPerPage}
        total_records={total_records}
        setUsersPerPage={setUsersPerPage}
        setCurrentPage={setCurrentPage}
      />}
    </>
  );
};

export default CustomerInfo;
